// extracted by mini-css-extract-plugin
module.exports = {"facetMenu":"XV","fixed":"YV","nonLayerdFacets":"ZV","productCount":"_V","facetBack":"aW","arrow":"bW"};